import * as angular from 'angular';

export class StorageService {
    constructor(
        private $log,
        private $sessionStorage: WindowSessionStorage,
        private $localStorage: WindowLocalStorage
    ) {}

    public storeToSession(key, value) {
        this.$sessionStorage[key] = value;
    }

    public fetchFromSession(key) {
        return this.$sessionStorage[key];
    }

    public removeFromSession(key) {
        delete this.$sessionStorage[key];
    }

    public removeFromSessionWithPrefix(prefix) {
        var storageKeys = Object.keys(this.$sessionStorage);
        for (var i = 0; i < storageKeys.length; i++) {
            if (storageKeys[i] && storageKeys[i].startsWith(prefix)) {
                this.removeFromSession(storageKeys[i]);
            }
        }
    }

    public clearSessionStorage() {
        for (var key in Object.getOwnPropertyNames(this.$sessionStorage)) {
            delete this.$sessionStorage[key];
        }
    }

    public cleanLocalStorage() {
        for (var key in Object.getOwnPropertyNames(this.$localStorage)) {
            if (
                key.startsWith('ngStorage-app_mem_platform_settings') ||
                key.startsWith('storageBooking_step1')
            ) {
                continue;
            }
            delete this.$localStorage[key];
        }
    }

    public keysFromSession() {
        var props = Object.getOwnPropertyNames(this.$sessionStorage);
        var keys = [];
        for (var i = 0; i < props.length; i++) {
            if (props[i].slice(0, 1) !== '$') {
                keys.push(props[i]);
            }
        }
        this.$log.debug('Session storage keys are: ' + props);
        this.$log.debug('Returned filtered keys are: ' + keys);
        return keys;
    }

    public storeToLocal(key, value) {
        this.$localStorage[key] = value;
    }

    public fetchFromLocal(key) {
        return this.$localStorage[key];
    }

    public removeFromLocal(key) {
        delete this.$localStorage[key];
    }

    public removeFromLocalWithPrefix(prefix) {
        var storageKeys = Object.keys(this.$localStorage);
        for (var i = 0; i < storageKeys.length; i++) {
            if (storageKeys[i] && storageKeys[i].startsWith(prefix)) {
                this.removeFromLocal(storageKeys[i]);
            }
        }
    }

    public keysFromLocal() {
        var props = Object.getOwnPropertyNames(this.$localStorage);
        var keys = [];
        for (var i = 0; i < props.length; i++) {
            if (props[i].slice(0, 1) !== '$') {
                keys.push(props[i]);
            }
        }
        this.$log.debug('Local storage keys are: ' + props);
        this.$log.debug('Returned filtered keys are: ' + keys);
        return keys;
    }
}

angular.module('app').service('storageService', StorageService);
